import { render, staticRenderFns } from "./HtmlPanel.vue?vue&type=template&id=20750c56&"
import script from "./HtmlPanel.vue?vue&type=script&lang=js&"
export * from "./HtmlPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports